<p-toast key="creationPiece"></p-toast>

<p-blockUI [blocked]="blocked">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-blockUI>


<p-card *ngIf="!EstCharge()">
    <app-loading [title]="'Chargement des pièces'" [httpEvent]="loadingEvent" [error]="loadingError"></app-loading>
</p-card>

<div #contenu *ngIf="EstCharge()">
	<div class="fluid formgrid grid" *ngIf="nouvelItem.categorie">
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-8 my-2">
			<label for="description">Description<span class="requis">*</span></label>
				<p-autoComplete #champDescription appendTo="body" [(ngModel)]="nouvelItem.description" [suggestions]="suggestionDescription" [loading]="!itemsLoaded" (completeMethod)="rechercherDescritpion($event)"></p-autoComplete>
			<small class="p-error" *ngIf="submitted && !nouvelItem.description">La description
				est
				obligatoire.</small>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4 my-2">
			<label for="marque">Marque</label>
			<p-autoComplete appendTo="body" [(ngModel)]="nouvelItem.marque" [suggestions]="suggestionMarque" (completeMethod)="rechercherMarque($event)"></p-autoComplete>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4 my-2">
			<label for="modele">Modèle</label>	
			<input type="text" pInputText id="modele" [(ngModel)]="nouvelItem.modele" autocomplete="off"
				autofocus />
		</div>

		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4 my-2" *ngIf="nouvelItem.categorie?.categorieId === 3">
			<label for="produitDangereux">Est Un Produit Dangereux</label>
			<p-toggleButton [(ngModel)]="nouvelItem.produitDangereux" inputId="produitDangereux" onLabel="Oui" offLabel="Non"></p-toggleButton>
		</div>

		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4 my-2">

			<label for="lastname">Localisation entrepot</label>
			<p-dropdown [options]="listeLocalisations" [(ngModel)]="nouvelItem.localisation" optionLabel="nom"
				appendTo="body" [showClear]="true" filter="true" filterBy="code,nom"
				placeholder="Sélectionner une localisation...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="nouvelItem.localisation">
						<div>{{nouvelItem.localisation.nom}}</div>
					</div>
				</ng-template>
				<ng-template let-loc pTemplate="item">
					<div>
						<div>{{loc.nom}}</div>
					</div>
				</ng-template>
			</p-dropdown>
		</div>

	</div>

	<p-divider align="left">
		<div class="inline-flex align-items-center">
			<b>Fournisseur</b>
		</div>
	</p-divider>

	<div class="fluid formgrid grid" *ngIf="nouvelItem.categorie">
		<div class="flex flex-column gap-2 col-12 lg:col-6 my-2">
			<label for="lastname">Fournisseur</label>
			<p-dropdown [options]="listeFournisseurs" [(ngModel)]="prixFournisseur.fournisseur" appendTo="body" optionLabel="nom" 
				[showClear]="true" filter="true" [virtualScroll]="true"
				[virtualScrollItemSize]="38" filterBy="numero,nom"
				placeholder="Sélectionner un fournisseur...">
				<ng-template pTemplate="selectedItem">
					<div class="flex align-items-center gap-2" tooltipPosition="left" pTooltip="{{prixFournisseur.fournisseur.nom}} ({{prixFournisseur.fournisseur.numero}})">
						<p-tag [severity]="fournisseurService.getQualityScore(prixFournisseur.fournisseur)"
						[value]="fournisseurService.getQualityScoreLabel(prixFournisseur.fournisseur)">
						</p-tag>
						<div>{{prixFournisseur.fournisseur.nom}} ({{prixFournisseur.fournisseur.numero}})</div>
					</div>
				</ng-template>
				<ng-template let-fournisseur pTemplate="item">
					<div class="flex align-items-center gap-2" tooltipPosition="left" pTooltip="{{fournisseur?.nom}} ({{fournisseur?.numero}})">
						<p-tag [severity]="fournisseurService.getQualityScore(fournisseur)"
						[value]="fournisseurService.getQualityScoreLabel(fournisseur)">
						</p-tag>
						<div>{{fournisseur?.nom}} ({{fournisseur?.numero}})</div>
					</div>
				</ng-template>
			</p-dropdown>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2" *ngIf="prixFournisseur.fournisseur != null">
            <label for="noFournisseur">No pièce fournisseur</label>
            <input #champNoFournisseur type="text" pInputText id="noFournisseur" [(ngModel)]="prixFournisseur.numeroFournisseur"
                autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2" *ngIf="prixFournisseur.fournisseur != null">
            <label for="prix">Prix</label>
            <p-inputNumber #champPrix [(ngModel)]="prixFournisseur.prix" mode="currency" currency="USD" locale="en-US" [minFractionDigits]="2" [maxFractionDigits]="4"></p-inputNumber>
        </div>
	</div> 

</div>


<div class="text-right mt-3">
	<button pButton pRipple label="Créer" icon="pi pi-save" class="p-button-primary"
	(click)="enregistrer()"></button>
<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
	(click)="annuler()"></button>
	

</div>